import React, { useEffect, useRef, useState } from "react";
import { createElement, init } from "@airwallex/components-sdk";
import { getEmbeddedInitApi } from "../../../api/api";
import { drupalSettings } from "../../../utils/config";
import { useLoader } from "../../Common/GeneralLoader/GeneralLoaderProvider";
import {
  hasSdkSubmissionError,
  isBeneficiaryFormDataComplete,
} from "../../Common/beneficiaryValidation";

export const EditBeneficiaryFormStep = ({ payload, setPayload, setStep }) => {
  const [submitError, setSubmitError] = useState("");
  const beneficiaryFormRef = useRef(null);
  const { showLoader, hideLoader } = useLoader();

  const formErrors = {
    form_incomplete: Drupal.t("Please complete all required fields before continuing."),
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitError("");
    if (!beneficiaryFormRef.current) return;

    const submitResult = await beneficiaryFormRef.current.submit();
    if (hasSdkSubmissionError(submitResult)) return;
    if (!isBeneficiaryFormDataComplete(submitResult?.values || {})) {
      setSubmitError(formErrors.form_incomplete);
      return;
    }

    setPayload((prev) => ({
      ...prev,
      beneficiaryFormData: submitResult.values,
    }));
    setStep(2);
  };

  useEffect(() => {
    const initAndRender = async () => {
      showLoader();
      try {
        const response = await getEmbeddedInitApi({ yacht_id: drupalSettings?.user?.yacht_id });
        const { authCode, clientId, codeVerifier } = response.data;
        await init({
          locale: "en",
          env: response?.env || "demo",
          authCode,
          clientId,
          codeVerifier,
        });

        const element = await createElement("beneficiaryForm", {
          defaultValues: payload?.beneficiaryFormData || {},
          customizations: {
            ui: { hideFeeConfig: true },
            fields: {
              "beneficiary.additional_info.personal_email": { hidden: true },
              nickname: { hidden: true },
              "beneficiary.company_name": { hidden: true },
              "beneficiary.first_name": { hidden: true },
              "beneficiary.last_name": { hidden: true },
            },
          },
        });
        element.mount("#edit-beneficiary-root");
        beneficiaryFormRef.current = element;
      } catch (err) {
        setStep(-1);
      } finally {
        hideLoader();
      }
    };
    initAndRender();
  }, []);

  return (
    <>
      <div className="add-recipient-header">
        <h4 className="add-recipient-title">{Drupal.t("Edit")} <span className="yellow">{Drupal.t("Recipient")}</span></h4>
      </div>
      <div className="add-recipient-body-content">
        <form className="add-new-recipient-form">
          {submitError && (
            <div className="popup-has-error">
              <div className="error_messages">{submitError}</div>
            </div>
          )}
          <div id="edit-beneficiary-root" />
          <div className="add-recipient-actions">
            <button className="secondary__btn" type="button" onClick={() => destoryReactApp()}>
              {Drupal.t("Cancel")}
            </button>
            <button className="primary__btn" type="submit" onClick={handleSubmit}>
              {Drupal.t("Confirm")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
